import React from "react"

import "./Profile.css"
import strings from "../../locales/ro.json"

import HeaderElement from "../../components/HeaderElement/HeaderElement";
import ProfileCard from "../../components/Profile/ProfileCard/ProfileCard";

const Profile = () => {

	return (
		<div>
			<HeaderElement headerText={strings.profile.title} />

			<div className="profilePageContent">
				<ProfileCard />
				<div className="profileEllipse"></div>
			</div>
		</div>
	);
}

export default Profile;